export default class ElinorNoPeeking extends Phaser.Group {
  constructor(game) {
    super(game);

    this.char = this.game.make.spine(0, 0, 'elinor_no_peeking', true);
    this.char.anchor.set(0.5, 1);
    this.char.setAnimationByName(0, 'animation', true);
    this.addChild(this.char);

    // this.idle();
  }

  idle() {
    this.char.setSkinByName('mouth/closed');
    this.char.setToSetupPose();
  }

  talk() {
    this.char.setSkinByName('mouth/talking');
    this.char.setToSetupPose();
  }
}
